const axios = require('@/utils/axios')
const {baseURL} = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	grade_subjects : [],
	current_grade_subject : null,
}

const getters = {
	fetchGradeSubjects : (state) => state.grade_subjects,
	fetchCurrentGradeSubject : (state) => state.current_grade_subject,
}

const actions = {
	loadGradeSubjects({commit}, {token, filter}){
		const query_arr = []
		for(let key in filter){
			if(filter[key]){
				query_arr.push(`${key}=${encodeURIComponent(filter[key])}`)	
			}
		}
		const query_str = query_arr.join('&')
		return $http.get(`gradesubject?${query_str}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_GRADE_SUBJECTS', response.data)
		})
	},

	loadGradeSubjectDetails({commit}, {id, token}){
		return $http.get(`gradesubject/${id}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_CURRENT_GRADE_SUBJECT', response.data)
		})
	},

	createGradeSubject({commit}, {grade_subject, token}){
		return $http.post('gradesubject', grade_subject, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			const data = response.data.success ? response.data.data : response.data
			commit('ADD_GRADE_SUBJECT', data)
		})
	},

	updateGradeSubject({commit}, {id, grade_subject, token}){
		return $http.put(`gradesubject/${id}`, grade_subject, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			const data = response.data.success ? response.data.data : response.data
			commit('SET_CURRENT_GRADE_SUBJECT', data)
			commit('UPDATE_GRADE_SUBJECT', data)
		})
	},

	deleteGradeSubject({commit}, {id, token}){
		return $http.delete(`gradesubject/${id}`, {
			headers : {
				'x-auth-token' : token
			} 
		}).then(() => {
			commit('REMOVE_GRADE_SUBJECT', id)	
		})
	},

	resetGradeSubjects({commit}){
		commit('SET_GRADE_SUBJECTS', [])
	}
}

const mutations = {
	SET_GRADE_SUBJECTS : (state, grade_subjects) => {
		state.grade_subjects = grade_subjects
	},
	SET_CURRENT_GRADE_SUBJECT : (state, grade_subject) => {
		state.current_grade_subject = grade_subject
	},
	UPDATE_GRADE_SUBJECT : (state, grade_subject) => {
		const gs_index = state.grade_subjects.findIndex(gs => gs._id == grade_subject._id)
		state.grade_subjects = [...state.grade_subjects.slice(0, gs_index), grade_subject, ...state.grade_subjects.slice(gs_index+1, state.grade_subjects.length)]
	},
	ADD_GRADE_SUBJECT : (state, grade_subject) => {
		state.grade_subjects.push(grade_subject)
	},
	REMOVE_GRADE_SUBJECT : (state, grade_subject_id) => {
		state.grade_subjects = state.grade_subjects.filter(grade => grade._id != grade_subject_id)
	},
}

export default {
	state, getters, actions, mutations
}